let SERVER_HOST_PATH = "";
let ERP_LINK_1 = "";

// Get only the hostname (without protocol or port)
const hostname = window.location.hostname;
const origin = window.location.origin;

if (hostname.includes("10.1.201.25")) {
    SERVER_HOST_PATH = "http://galera.10.1.201.25.nip.io/api";
    ERP_LINK_1 = "http://galera.10.1.201.25.nip.io";
}else if (hostname.includes("cbm.10.1.201.68.nip.io")) {
    SERVER_HOST_PATH = "http://cbm.10.1.201.68.nip.io/api";
    ERP_LINK_1 = "http://cbm.10.1.201.68.nip.io";
}else if (hostname.includes("css.10.1.201.68.nip.io")) {
    SERVER_HOST_PATH = "http://css.10.1.201.68.nip.io/css/api";
    ERP_LINK_1 = "http://css.10.1.201.68.nip.io";
}else if (hostname.includes("qa.10.1.201.68.nip.io")) {
    SERVER_HOST_PATH = "http://qa.10.1.201.68.nip.io/css/api";
    ERP_LINK_1 = "http://qa.10.1.201.68.nip.io";
} else if ((hostname === "cbmfooderp.com")||(hostname === "www.cbmfooderp.com")) {
    SERVER_HOST_PATH = "https://cbmfooderp.com/api";
    ERP_LINK_1 = "https://cbmfooderp.com";
} else if (hostname === "www.cbmfooderp.com") {
    SERVER_HOST_PATH = "https://cbmfooderp.com/api";
    ERP_LINK_1 = "https://cbmfooderp.com";
} else if (hostname.includes("localhost")) {
    // SERVER_HOST_PATH = "http://10.1.201.68:32017";  // Change this to your local server path
    SERVER_HOST_PATH = "https://cbmfooderp.com/api";  // Change this to your local server path
    ERP_LINK_1 = "http://192.168.1.34:3000";          
} else if (hostname === "10.4.5.69") {
    SERVER_HOST_PATH = "http://10.4.5.69:8000";
    ERP_LINK_1 = "http://10.4.5.69:3000";
} else if (window.location.host === "192.168.1.114:3000") {
    SERVER_HOST_PATH = "http://192.168.1.114:8000";
    ERP_LINK_1 = "http://192.168.1.114:3000";;
} else if (window.location.host  === "192.168.1.114:3001") {
    SERVER_HOST_PATH = "http://192.168.1.114:8002";
    ERP_LINK_1 = "http://192.168.1.114:3001";
} else if (hostname.includes("demo.chitalesweets.com")) {
    SERVER_HOST_PATH = "https://demo.chitalesweets.com/api";
    ERP_LINK_1 = "https://demo.chitalesweets.com";
} else if (hostname.includes("knode1.cbmfooderp.com")) {     // CBM master & worker server
    SERVER_HOST_PATH = "https://knode1.cbmfooderp.com/api";
    ERP_LINK_1 = "https://knode1.cbmfooderp.com/login";
} else if (hostname.includes("cbmfooderp.10.4.5.71.nip.io")) {         // workernode
    SERVER_HOST_PATH = "http://cbmfooderp.10.4.5.71.nip.io/api";
    ERP_LINK_1 = "http://cbmfooderp.10.4.5.71.nip.io/login";
} else if (hostname.includes("css.ranje.10.4.5.70.nip.io")) {         //Css BackUp on ranje
    SERVER_HOST_PATH = "http://css.ranje.10.4.5.70.nip.io/api";
    ERP_LINK_1 = "http://css.ranje.10.4.5.70.nip.io/login";
} else if (hostname.includes("10.4.5.70")) {
    SERVER_HOST_PATH = "http://10.4.5.70:32015";
    ERP_LINK_1 = "http://10.4.5.70:32014";
} else if (hostname.includes("ra.fooderp.in")) {
    SERVER_HOST_PATH = "https://ra.fooderp.in/api";
    ERP_LINK_1 = "https://ra.fooderp.in";
}


if (origin=== "http://fooderp.in") {
    SERVER_HOST_PATH = "http://fooderp.in/api";
    ERP_LINK_1 = "http://fooderp.in";
} else if (origin==="https://fooderp.in") {
    SERVER_HOST_PATH = "https://fooderp.in/api";
    ERP_LINK_1 = "https://fooderp.in";
}


if (origin=== "https://fooderp.chitalesweets.com") {
    SERVER_HOST_PATH = "https://fooderp.chitalesweets.com/api";
    ERP_LINK_1 = "https://fooderp.chitalesweets.com";
} else if (origin==="http://fooderp.chitalesweets.com") {
    SERVER_HOST_PATH = "http://fooderp.chitalesweets.com/api";
    ERP_LINK_1 = "http://fooderp.chitalesweets.com";
}else if (origin=== "https://10.1.201.27") {
    SERVER_HOST_PATH = "https://10.1.201.27/api";
    ERP_LINK_1 = "https://10.1.201.27";
} else if (origin=== "http://10.1.201.27") {
    SERVER_HOST_PATH = "http://10.1.201.27:32015";
    ERP_LINK_1 = "http://10.1.201.27:32014";
} else if (origin=== "http://10.1.201.27:32014") {
    SERVER_HOST_PATH = "http://10.1.201.27:32015";
    ERP_LINK_1 = "http://10.1.201.27:32014";
}
// Export values 'http://10.1.201.27:32014'
export const ERP_LINK = ERP_LINK_1;
export default SERVER_HOST_PATH;
